<!-- <div class="loading-overlay">
  <p-progressSpinner></p-progressSpinner>
</div> -->
<div class="new-payments-container">
  <div class="label sub-title title-fix">
    {{'Pagos nacionales' | translate}}
  </div>

  <div class="currencies-container">
    <div class="balance">
      {{'Saldo Disponible'}}
    </div>
    <div class="currencies d-flex mt-1">
      <ng-container *ngIf="!loadingBalances; else waitBalances">
        <div
          class="currency"
          *ngFor="let currency of currenciesByContractId"
          [ngClass]="
            {
              'hovered': isHoveredClass(currency),
              'balance-negative': isBalanceNegative(currency)
            }
          "
        >
          <ng-container *ngIf="currenciesByContractId.length > 0">

              <span style="margin-right: 3px;">
                {{currency.balance}}
              </span>
              <span> {{currency.cveCurrency}}</span>

          </ng-container>
        </div>
      </ng-container>
      <ng-template #waitBalances>
        <div
          class="currency ms-4"
        >
          <p-skeleton height="1rem" width="10vw" ></p-skeleton>
          <p-skeleton height="1rem" width="10vw" ></p-skeleton>
          <p-skeleton height="1rem" width="10vw" ></p-skeleton>
        </div>
      </ng-template>
    </div>
    <div class="required-fields-container">
      *Campos obligatorios
    </div>
  </div>
  <span
    class="p-input-icon-right input-receiver disabled mt-5"
    style="border-radius: 6px;"
    *ngIf="inputReceiverValue"
  >
    <i
      class="pi pi-times"
      [ngClass]="{'icon-clear' : inputReceiverValue}"
      (click)="clearInputReceiver()"
    >
    </i>
      <div
        id="receiver"
        class="form-control disabled testing"
        readonly
        [innerHTML]="inputReceiverValue"
      >

      </div>
  </span>
  <form
    class="payment-form-container mt-3"
    [formGroup]="internationalPaymentForm"
    (ngSubmit)="showOperationResume()"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="mb-3 col-12 col-md-6 col-lg-3 column-display">
          <div class="w-100">
            <label class="form-label">*{{'Destinatario' | translate}}(s)</label>
            <p-autoComplete
              #receiverInput
              inputId="receiverInput"
              formControlName="receiverSelected"
              [suggestions]="filteredNames"
              (completeMethod)="filterNames($event)"
              (onSelect)="fillInputReceiver()"
              (onClear)="clearInputReceiver()"
              field="personName"
              [showClear]="true"
              [emptyMessage]="'No receivers in this contract'"
              [size]="30"
              [minLength]="3"
              placeholder="{{'Selecciona un destinatario' | translate}}"
            >
              <ng-template let-item pTemplate="item">
                <ng-container *ngIf="!loadingContracts; else waitContracts">
                  <div class="alias mb-2">{{item?.identificationName}}</div>
                  <div class="fullName mt-2">{{item?.personName}}</div>
                  <div class="bankAccount mt-2">{{item?.comment}} {{ocultarNumeros(item?.beneficiaryAccount)}}</div>
                  <div class="currency mt-2">Divisa: {{item?.descriptionCurrency}}</div>
                </ng-container>
                <ng-template #waitContracts>
                  <div class="inputCurrencyWrapper">
                    <div class="spinner-border text-secondary" role="status">
                    </div>
                  </div>
                </ng-template>
              </ng-template>
            </p-autoComplete>
          </div>

        </div>
        <div class="mb-3 col-lg-3 col-md-6 col-12 column-display">
          <div class="w-100">
            <label for="countryCode" class="form-label">*{{'Cargo de comisiones'|translate}}</label>

            <p-dropdown
              formControlName="commissionCharge"
              [options]="commissionChargeArr"
              placeholder="Selecciona una opcion"
              optionValue="key"
              optionLabel="value"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="mb-3 col-lg-3 col-md-6 col-12 column-display">
          <div class="w-100">
            <label for="amount" class="form-label w-100">*{{'Importe'|translate}}</label>
            <div class="inputCurrencyWrapper" [ngClass]="amountExceeded ? 'amountExceeded borderColorDanger' : ''">
              <span class="currencySymbol" >
                {{ internationalPaymentForm?.getRawValue()?.receiverSelected?.currency ? getCurrencySymbol() : '$' }}
              </span>
              <input
                id="amount"
                type="number"
                formControlName="amount"
                class="hidding form-control"

                [ngClass]="amountExceeded ? 'amountExceeded' : ''"
                placeholder="0.00"
                [readOnly]="!internationalPaymentForm.getRawValue()?.receiverSelected?.descriptionCurrency"
              />
            </div>
          </div>
          <div class="w-100 input-message">
            <span
              *ngIf="inputReceiverValue"
              [ngClass]="amountExceeded ? 'amountExceeded' : ''"
            >
              Saldo disponible: {{calculateTotal()}}
            </span>
          </div>
        </div>

        <div
          class="mb-3 col-lg-3 col-md-6 col-12 column-display"
          *ngIf="!this.hideImporteNeto"
        >
          <div class="w-100">
            <label for="amountNeto" class="form-label w-100">{{'Importe Neto'|translate}}</label>
            <div
              class="inputCurrencyWrapper "
              [ngClass]="amountExceeded ? 'amountExceeded bgAmtExc' : 'disabled'"
              style="border: none; "
              >
              <span class="currencySymbol" [ngClass]="amountExceeded ? 'amountExceeded' : ''">
                {{ internationalPaymentForm.getRawValue()?.receiverSelected?.currency ? getCurrencySymbol() : '$' }}
              </span>
              <input
                id="receiver"
                type="text"
                class="form-control input-receiver "
                style="border: none;"
                [ngClass]="amountExceeded ? 'amountExceeded bg-transparent' : 'disabled-input'"
                readonly
                placeholder="0.00"
                [value]="importeNeto != 0 ? importeNeto : ''"
              >
            </div>
          </div>
          <ng-container *ngIf="!loadingCommission; else waitCommission">
            <div class="w-100 input-message" >
              <p [ngClass]="amountExceeded ? 'amountExceeded' : ''">
                Importe + Comisión: {{this.commission < 9 ? (this.commission | number: '1.2-2') : (this.commission | number: '2.2-2')}} + IVA: {{this.iva | number: '1.2-2'}}
              </p>
            </div>
          </ng-container>
          <ng-template #waitCommission>
            <div class="spinner-border text-secondary" role="status" style="scale: 0.6;">
            </div>
          </ng-template>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 col-12 col-md-6 col-lg-3 column-display">
          <div class="w-100">
            <label class="form-label">*{{'Motivo de pago' | translate}}</label>
            <p-dropdown
              formControlName="paymentReason"
              [options]="paymentReasonsArr"
              placeholder="Selecciona una opcion"
              optionValue="code"
              optionLabel="description"
            >
            </p-dropdown>
          </div>
        </div>
        <div class="mb-3 col-12 col-lg-6 col-lg-3 column-display">
          <div class="w-100">
            <label class="form-label">*{{'Informacion para el destinatario' | translate}}</label>
            <input
              type="text"
              class="form-control"
              style="border: 1px solid black; height: 42px;"
              id="receiverInformation"
              formControlName="receiverInformation"
              placeholder="Maximo 140 caracteres"
              maxlength="140"
            >
          </div>
        </div>
        <!-- se añadira luego trayendo el mensaje adjuntado en la alta -->
        <!-- <div class="mb-3 col-12 col-md-6 col-lg-3 column-display">
          <div class="w-100">
            <label class="form-label">*{{'Mensaje banco pagador' | translate}}</label>
            <input
              type="text"
              class="form-control"
              style="border: 1px solid black; height: 42px;"
              id="receiverInformation"
              formControlName="receiverInformation"
              placeholder="Maximo 140 caracteres"
              maxlength="140"
            >
          </div>
        </div> -->
      </div>
      <div class="row schedule-payment-container">
        <div class="schedule-payment">
          <div class="schedule-payment-label">
            ¿Deseas programar la fecha de pago?
          </div>
          <div class="custom-switch">
            <input type="checkbox" id="schedulePayment" class="switch-input"
                   (change)="schedulePaymentMethod()" formControlName="schedulePayment">
            <label for="schedulePayment" class="switch-label">
              <div class="checkmark">
                <span class="text-roboto yes-label" id="yesLabel" style="color: white;">Si</span>
                <span class="text-roboto no-label" id="noLabel">No</span>
              </div>
            </label>
            <span class="switch-handle"></span>
          </div>
        </div>
      </div>
      <div class="row schedule-payment-calendar" *ngIf="this.internationalPaymentForm.getRawValue()?.schedulePayment">
        <div class="label">
          Fecha de pago
        </div>
        <p-calendar styleClass="calendar-custom" formControlName="date" [minDate]="minDate" (onSelect)="formattingDate()" [showIcon]="true" dateFormat="dd/mm/yy"></p-calendar>
      </div>
    </div>
    <div class="row">
      <div class="col" style="margin-top: 2.5rem;">
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="validateSubmitButton()"
        >
          {{'Continuar'|translate}}
        </button>
      </div>
    </div>
  </form>
</div>
{{this.internationalPaymentForm.getRawValue() | json}}
